import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  Form,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import MsgToast from "../../../Components/Common/MsgToast";
import ProccessingLoader from "../../../Components/Loaders/ProccessingLoader";
import { useFormik } from "formik";
import * as Yup from "yup";
import { APIClient } from "../../../utils/api_helper";
import TextField from "../../../Components/Common/Fields/TextField";
import { useDispatch, useSelector } from "react-redux";
import { getCards } from "../../../store/actions";
import useSWR from "swr";
import usdtCoin from "../../../assets/images/svg/crypto-icons/usdt.svg";

import { topPerformers } from "../../../common/data";

const api = new APIClient();

const loanTypeFetcher = async (url) => {
  const data = await api.get(url);

  return data;
};

const loanImages = {
  personal: "/static/personalloan.png",
  health: "/static/healthloan.png",
  student: "/static/studentloan.png",
  business: "/static/businessloan.png",
};

const LoanModal = ({ openModal, setOpenModal, link }) => {
  let { data: loanTypesList, isValidating } = useSWR(`/loan/types/`, loanTypeFetcher, {
    revalidateOnFocus: false, // revalidate when the page gains focus
    revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
  });

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  const [modal, setModal] = useState(false);

  console.log(loanTypesList, "LOANN__TYPEE_DATATA");

  const [alert, setAlert] = useState({
    status: false,
    title: "Proccessing...",
    message: "Adding sssscard, please wait...",
    class: "spinner-border spinner-border-lg",
    textClass: "text-primary",
  });

  return (
    <React.Fragment>
      <Modal
        id="topmodal"
        isOpen={openModal}
        toggle={() => {
          // setOpenModal(false);
          // topBordertoggle("1");
        }}
      >
        <ModalHeader
          className="modal-title"
          id="myModalLabel"
          toggle={() => {
            setOpenModal(false);
            // topBordertoggle("1");
          }}
        ></ModalHeader>
        <ModalBody className="">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Below is your crowdfund link</h4>
          </CardHeader>
          <Row>
            <Col xxl={10} lg={10}>
              <Card className="card-height-100">
                <CardBody className="p-0">
                  <ul className="list-group list-group-flush border-dashed mb-0">{link}</ul>
                </CardBody>
              </Card>
            </Col>
            <Col xxl={2} lg={2}>
              <Button
                // onClick={() => setOpenLoanModal(!openLoanModal)}
                color="info"
                className="btn-sm w-20 text-center"
              >
                <i className="ri-question-answer-line align-bottom me-1"></i> copy link
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <ProccessingLoader alert={alert} setAlert={setAlert} />
    </React.Fragment>
  );
};

export default LoanModal;
